import api from "../axios";

export const getCustomerLists = async (queryParams) => {
    try {
        const response = await api.get(`/api/v1/admin/users/customers?${queryParams}`);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Failed to update email. Please try again.");
    }
};

export const getCustomerByID = async (id) => {
    try {
        const response = await api.get(`/api/v1/admin/users/customers/${id}`);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Failed to update email. Please try again.");
    }
};

export const getApprovalLists = async (queryParams) => {
    try {
        const response = await api.get(`/api/v1/admin/users/approval?${queryParams}`);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Failed to update email. Please try again.");
    }
};

export const getApprovalCustomerByID = async (id) => {
    try {
        const response = await api.get(`/api/v1/admin/users/approval/${id}`);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Failed to update email. Please try again.");
    }
};

export const getUserMedias = async (id) => {
    try {
        const response = await api.get(`/api/v1/admin/users/media/${id}`);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Failed to update email. Please try again.");
    }
};

export const getUserMediaUpdate = async (id) => {
    try {
        const response = await api.get(`/api/v1/admin/users/mediaupdate/${id}`);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Failed to update email. Please try again.");
    }
};

export const getUserQuestions = async (id) => {
    try {
        const response = await api.get(`/api/v1/admin/users/user/questions/${id}`);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Failed to update email. Please try again.");
    }
};

export const getUserUpdateRequestedUser = async (id) => {
    try {
        const response = await api.get(`/api/v1/admin/users/UpdateRequestedUser/${id}`);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Failed to update email. Please try again.");
    }
};

export const updateUserStatus = async (userDetails) => {
    try {
        const response = await api.put("/api/v1/admin/users/updatestatus", userDetails);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Failed to update email. Please try again.");
    }
};

export const deleteUser = async (userDetails) => {
    try {
        const response = await api.put("/api/v1/admin/users/deleteuser", userDetails);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Failed to update email. Please try again.");
    }
};

export const updateRejected = async (userDetails) => {
    try {
        const response = await api.post("/api/v1/admin/rejected/updateRejected", userDetails);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Failed to update email. Please try again.");
    }
};

export const deleteMediaUpdate = async (id) => {
    try {
        const response = await api.delete(`/api/v1/admin/users/deleteMediaUpdate/${id}`);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Failed to update email. Please try again.");
    }
};

export const deleteAnswerquestions = async (id) => {
    try {
        const response = await api.delete(`/api/v1/admin/users/deleteAnswerquestions/${id}`,);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Failed to update email. Please try again.");
    }
};

export const UpdateAndDeleteOldMedia = async (id) => {
    try {
        const response = await api.post(`/api/v1/admin/users/replaceMediaData/${id}`,);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Failed to update email. Please try again.");
    }
};

export const updateQuestionAnswers = async (id) => {
    try {
        const response = await api.post(`/api/v1/admin/users/updateQuestionAnswers/${id}`,);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Failed to update email. Please try again.");
    }
};

export const updateUserSocket = async (id, payload) => {
    try {
        const response = await api.post(`/api/v2/user/updateUserSocket/${id}`, payload);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Failed to update email. Please try again.");
    }
};